
import React, { useEffect, useState } from "react";
import "../../assets/css/login.css";
import { Link, useNavigate } from 'react-router-dom';
import { Button, Form, FormGroup } from "react-bootstrap";
import authLayout from "../../hoc/authLayout";
import axios from "axios";
import OtpInput from 'react-otp-input'
import logo from "../../assets/images/logo.png"
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { BaseUrl } from "../../utils/Token";


const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [otp, setOtp] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [isClicked, setIsClicked] = useState(false);
    const navigate = useNavigate();

    const handleClick = async (event) => {
        event.preventDefault();

        try {
            const response = await axios.post(`${BaseUrl}/enter_username`, {
                username: username
            });
            setMessage(response.data.message);
            setStatus(response.data.status);
            console.log(response.data.message);
            // setOtp(response.data.message)
            // toast.success("OTP has been sent to your registered mobile number.");
            toast.success(
                response?.data?.message
                    ? `OTP sent successfully. ${response.data.message}`
                    : "OTP sent successfully. Please check your phone."
            );



            if (response.data.status === 'OK') {
                setIsClicked(true);
            } else {
                toast.error("User has not access to login")
            }
            if (response.data.message == "NOT FOUND") {
                toast.error("User Not Found")
            }

        } catch (error) {
            console.error(error);
        }
    };

    const handleOtpClick = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${BaseUrl}/authenticated_login`, {
                username: username,
                otp: otp
            });

            if (response.status === 200) {
                // navigate("/");
                // Handle successful login
                if (Number(otp) === message) {
                    if (response.data.data.type == "Admin" || response.data.data.type == "Staff") {
                        const token = response.data.token;

                        localStorage.setItem('token', token)
                        localStorage.setItem("userid", response.data.data._id)
                        localStorage.setItem("usertype", response.data.data.type)
                        if (response.data.data.type == "Admin") {
                            // navigate("/dashboard");
                            window.location.href = '/dashboard'
                        } else {
                            // navigate('/ticket')
                            window.location.href = '/ticket'

                        }
                        // window.location.reload()
                    } else {
                        toast.error("You Are Not Login")
                    }
                    console.log(response.data.data)


                } else {
                    toast.error("it does not mathces")
                    // console.log(typeof otp)
                    // console.log(typeof message)
                }
                // Redirect to the dashboard page
            } else {
                // Handle login error
                console.log(response);
                toast.error("Login failed. Please check your credentials.");
            }
        } catch (error) {
            console.error("Login error:", error);
            toast.error("An error occurred while trying to login. Please try again later.");
        }
    };

    const handleChange = (event) => {
        setUsername(event.target.value);
    };


    return (
        <>
            <ToastContainer />
            <h3 className="outletheading">
                <img src={logo} className="img-fluid p-3"></img>
            </h3>
            {isClicked ? (
                <>
                    <Form onSubmit={handleOtpClick} className="login-form p-3">

                        <div className="d-flex align-items-center my-4 justify-content-center w-100">
                            <h1 className="text-center fw-normal mb-0 me-3" style={{ color: "#1D5D9B" }}>Sign In</h1>
                        </div>
                        <FormGroup className="mt-3 OtpBox">
                            <label className="mb-1 fw-bold" htmlFor="otp">
                                OTP
                            </label>
                            {/* <input
                                type="text"
                                className="form-control"
                                placeholder="OTP"
                                required
                                id="otp"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                            // onChange={handleOtp}
                            /> */}
                            <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                className="form-control "
                                renderSeparator={<span className="me-2"> </span>}
                                renderInput={(props) => <input {...props} />}
                            />
                        </FormGroup>
                        <button className="btn mt-3 auth_btn w-100" type="submit">
                            Login
                        </button>
                    </Form>
                </>
            ) : (
                <>
                    <Form onSubmit={handleClick} className="login-form p-3">

                        <div className="d-flex align-items-center my-4 justify-content-center w-100">

                            <h1 className="text-center fw-normal mb-0 me-3" style={{ color: "#1D5D9B" }}>Sign In</h1>
                        </div>
                        <FormGroup className="mt-3">
                            <label className="mb-1 fw-bold mb-2" htmlFor="name">
                                Username
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Username "
                                required
                                id="name"
                                value={username}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <button className="btn mt-3 auth_btn w-100" type="submit">
                            Login
                        </button>
                    </Form>

                </>
            )}

            {/* {isClicked && toast.success(`Your Otp is ${message}`)} */}
            {/* {status && <p>Status: {status}</p>} */}

        </>
    );
};

export default authLayout(LoginPage);

